import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _793373f9 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _6abf689c = () => interopDefault(import('..\\pages\\have-a-card.vue' /* webpackChunkName: "pages_have-a-card" */))
const _3668dc90 = () => interopDefault(import('..\\pages\\have-a-card\\index.vue' /* webpackChunkName: "pages_have-a-card_index" */))
const _3551a136 = () => interopDefault(import('..\\pages\\have-a-card\\enrollment.vue' /* webpackChunkName: "pages_have-a-card_enrollment" */))
const _3a27fc7e = () => interopDefault(import('..\\pages\\have-a-card\\success.vue' /* webpackChunkName: "pages_have-a-card_success" */))
const _e2681e0c = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _1b1b87a3 = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _541b5497 = () => interopDefault(import('..\\pages\\upload-documents\\index.vue' /* webpackChunkName: "pages_upload-documents_index" */))
const _3fee0bda = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _3ffc235b = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _4018525d = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _402669de = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _74d4471b = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _2f952a79 = () => interopDefault(import('..\\pages\\need-a-card\\eligibility.vue' /* webpackChunkName: "pages_need-a-card_eligibility" */))
const _6c81a446 = () => interopDefault(import('..\\pages\\need-a-card\\insurance.vue' /* webpackChunkName: "pages_need-a-card_insurance" */))
const _f05ae2b6 = () => interopDefault(import('..\\pages\\need-a-card\\insurance-information.vue' /* webpackChunkName: "pages_need-a-card_insurance-information" */))
const _063481d0 = () => interopDefault(import('..\\pages\\need-a-card\\patient-information.vue' /* webpackChunkName: "pages_need-a-card_patient-information" */))
const _20fb8b48 = () => interopDefault(import('..\\pages\\need-a-card\\prescriber-information.vue' /* webpackChunkName: "pages_need-a-card_prescriber-information" */))
const _e05d6e7c = () => interopDefault(import('..\\pages\\need-a-card\\select-path.vue' /* webpackChunkName: "pages_need-a-card_select-path" */))
const _0f7d3422 = () => interopDefault(import('..\\pages\\need-a-card\\success.vue' /* webpackChunkName: "pages_need-a-card_success" */))
const _79d5c772 = () => interopDefault(import('..\\pages\\patient\\patientSearch.vue' /* webpackChunkName: "pages_patient_patientSearch" */))
const _356d55c3 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _793373f9,
    name: "error"
  }, {
    path: "/have-a-card",
    component: _6abf689c,
    children: [{
      path: "",
      component: _3668dc90,
      name: "have-a-card"
    }, {
      path: "enrollment",
      component: _3551a136,
      name: "have-a-card-enrollment"
    }, {
      path: "success",
      component: _3a27fc7e,
      name: "have-a-card-success"
    }]
  }, {
    path: "/rejection",
    component: _e2681e0c,
    name: "rejection"
  }, {
    path: "/unlock",
    component: _1b1b87a3,
    name: "unlock"
  }, {
    path: "/upload-documents",
    component: _541b5497,
    name: "upload-documents"
  }, {
    path: "/errors/400",
    component: _3fee0bda,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _3ffc235b,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _4018525d,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _402669de,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _74d4471b,
    name: "errors-500"
  }, {
    path: "/need-a-card/eligibility",
    component: _2f952a79,
    name: "need-a-card-eligibility"
  }, {
    path: "/need-a-card/insurance",
    component: _6c81a446,
    name: "need-a-card-insurance"
  }, {
    path: "/need-a-card/insurance-information",
    component: _f05ae2b6,
    name: "need-a-card-insurance-information"
  }, {
    path: "/need-a-card/patient-information",
    component: _063481d0,
    name: "need-a-card-patient-information"
  }, {
    path: "/need-a-card/prescriber-information",
    component: _20fb8b48,
    name: "need-a-card-prescriber-information"
  }, {
    path: "/need-a-card/select-path",
    component: _e05d6e7c,
    name: "need-a-card-select-path"
  }, {
    path: "/need-a-card/success",
    component: _0f7d3422,
    name: "need-a-card-success"
  }, {
    path: "/patient/patientSearch",
    component: _79d5c772,
    name: "patient-patientSearch"
  }, {
    path: "/",
    component: _356d55c3,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
